import React, { memo, useState, useEffect, Fragment } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold'
  }
});

export default WithApp(function ModalDiferencePriceProducts(props) {
  const classes = useStyles();
  const { productsDetail = [] } = props;

  const matchedProducts = productsDetail
    .map((prod) => {
      const numPerMsr = parseInt(prod.NumPerMsrSAP ?? 0, 10);
      const price = parseFloat(prod.price ?? 0);
      const last_purchase_price = parseFloat(prod.last_purchase_price ?? 0);
      let unitPrice = 0;
      if(prod.UnitMsr === null || prod.UnitMsr === 'NIU' || prod.UnitMsr === 'PZA'){
        unitPrice = parseFloat(prod.price ?? 0);
      }else{
        unitPrice = numPerMsr > 0 ? parseFloat((price / numPerMsr).toFixed(2)) : 0;
      }

      const difference = parseFloat((unitPrice - last_purchase_price).toFixed(2));

      if (Math.abs(difference) <= 0.05) {
        return null;
      }

      return {
        FrgItem: prod.FrgItem,
        ItemCode: prod.ItemCode,
        ItemName: prod.ItemName,
        NumPerMsrSAP: numPerMsr,
        last_purchase_price,
        price,
        unitPrice,
        difference,
      };
    })
    .filter(Boolean);

  const getRowStyle = (difference) => {
    if (difference > 0) return { backgroundColor: "#d2f8d2" };
    if (difference < 0) return { backgroundColor: "#f8d2d2" };
    return {};
  };

  return (
    <Modal
      title="Validación de diferencia entre precios"
      model={{ open: props.open }}
      setOpen={props.onClose}
      showNotify={props.showNotify}
      hideSave
      arrDataResponse
    >
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="tabla de productos">
          <TableHead>
            <TableRow>
              <TableCell>Cód. prod. prov.</TableCell>
              <TableCell>Código</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell align="center">Precio unitario</TableCell>
              <TableCell align="center">Último precio de compra</TableCell>
              <TableCell align="center">Diferencia</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {matchedProducts.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No se encontraron diferencias de precio.
                </TableCell>
              </TableRow>
            )}

            {matchedProducts.map((p) => (
              <TableRow
                key={p.ItemCode}
                style={getRowStyle(Number(p.difference))}
              >
                <TableCell>{p.FrgItem}</TableCell>
                <TableCell>{p.ItemCode}</TableCell>
                <TableCell>{p.ItemName}</TableCell>
                <TableCell align="center">{p.unitPrice.toFixed(2)}</TableCell>
                <TableCell align="center">{p.last_purchase_price.toFixed(2)}</TableCell>
                <TableCell align="center">{p.difference}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
});

